import React, { useEffect } from 'react';
import { ApiAuth } from '../../api/auth';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { StyledForgotPassword } from './styled';
import Logo from '../../components/Logo';
import { makeStyles } from '../../utils/styles';
import FormForgotPassword from '../../forms/FormForgotPassword';
import { useApi } from '../../hooks/useApi';
import { toast } from 'react-toastify';
import { paths } from '../../routes';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((css) => ({
    logo: css`
        margin-bottom: 50px;
    `,
}));

const ForgotPassword = () => {
    const styles = useStyles();
    const history = useHistory();
    const user = useSelector(state => state.auth.user);
    const { t } = useTranslation()
    //Setup request
    const [{ loading }, forgotPasswordManager] = useApi(ApiAuth.forgotPasswordManager, { manual: true });

    //Call request
    const handleSubmit = async (data) => {
        const res = await forgotPasswordManager(data);
        if (res?.data) {
            toast.success(t("Na podany adres email został wysłany link do zmiany hasła."));
            history.push(paths.login);
        }
    };

    //redirect when user is logged in
    useEffect(() => {
        if (user?.jwt) {
            history.push(paths.jobs);
        }
    }, [user, history]);

    return (
        <StyledForgotPassword>
            <Logo
                variant="white"
                customStyle={styles.logo}
            />
            <FormForgotPassword loading={loading} onSubmit={handleSubmit} />
        </StyledForgotPassword>
    )
}

export default ForgotPassword;
